import schedule from "./schedule";
import video from "./video";
import personalization from "./personalization";
import pageSetting from "./pageSetting";
import { combineReducers } from "redux";

const NOOP = (state = {}) => state;

const root = combineReducers({
    schedule,
    video,
    personalization,
    pageSetting,
    // constants
    clientConfig: NOOP,
    liveNow: NOOP,
    live: NOOP,
    audio: NOOP,
    curation: NOOP,
    quicktakeVideo: NOOP,
    breakingNews: NOOP,
    cojpPath: NOOP,
});

export default root;
